import { StringUtil } from "@mcleod/core";
import { DataSourceMode, DropdownItem, LayoutProps } from "@mcleod/components";
import { AutogenLayoutBrokerageTrackingControlPanel } from "./autogen/AutogenLayoutBrokerageTrackingControlPanel";

interface BrokerageTrackingControlPanelLayoutProps extends LayoutProps {
    vendorId: string;
}
const USER = new DropdownItem("D", "Carrier Sales Rep");
const SHIPMENT_DEFAULT = new DropdownItem("CR", "Consignee reference");

export class BrokerageTrackingControlPanel extends AutogenLayoutBrokerageTrackingControlPanel {
    private _vendorId: string;
    private macropointVendorId = "M";
    private project44VendorId = "P";
    private truckerToolsVendorId = "L";
    private fourKitesVendorId = "F";

    constructor(props?: Partial<BrokerageTrackingControlPanelLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId;
    }

    async onLoad() {
      this.mainDataSource.addAfterModeChangeListener(event => {
            if (event.newMode === DataSourceMode.ADD) {
                if (this.mainDataSource.activeRow == null) {
                    return;
                }
                this.activeRow.setValues(this.getDefaultData());
            }
        });
        this.modifyLabelCaptionsAndFieldVisibility(this.getDefaultData());
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("vendor", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch (error) {
            return false;
        }
    }

    private modifyLabelCaptionsAndFieldVisibility(defaultData: any) {
        this.layoutMainBrokerageTrackingControlPanel.switchAutomateArrivalsandDepartures.visible = defaultData?.is_licensed_for_symphony;
        this.layoutMainBrokerageTrackingControlPanel.textboxInboundMessageOption.visible = false;
        this.layoutMainBrokerageTrackingControlPanel.textboxOutboundMessageOption.visible = false;
        this.layoutMainBrokerageTrackingControlPanel.textboxInboundMessageOption.required = false;
        this.layoutMainBrokerageTrackingControlPanel.textboxOutboundMessageOption.required = false;

        if (StringUtil.equalsIgnoreCase(this._vendorId, this.macropointVendorId)) {
            this.layoutBrokerageTrackingCredentialsPanel.macropointCredentialsPanel.visible = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxAccountID.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxPassword.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxWebUser.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxWebPassword.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxMacropointUrl.required = true;
            this.layoutVendorPanel.textboxNearCityRadius.required = true;
            this.layoutVendorPanel.macropointVendorOptionsPanel.visible = true;
            this.layoutVendorPanel.textboxRecipents.selectedItem = USER;
            this.layoutMainBrokerageTrackingControlPanel.textboxInboundMessageOption.required = true;
            this.layoutMainBrokerageTrackingControlPanel.textboxOutboundMessageOption.required = true;
            this.layoutMainBrokerageTrackingControlPanel.textboxInboundMessageOption.visible = true;
            this.layoutMainBrokerageTrackingControlPanel.textboxOutboundMessageOption.visible = true;

        } else if (StringUtil.equalsIgnoreCase(this._vendorId, this.project44VendorId)) {
            this.layoutBrokerageTrackingCredentialsPanel.project44CredentialsPanel.visible = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxProject44AccountID.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxP44Password.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxP44Url.required = true;
            this.layoutMainBrokerageTrackingControlPanel.switchAutoSend.visible = false;
            this.layoutVendorPanel.textboxNearestCityRadius.required = true;
            this.layoutVendorPanel.project44VendorOptionsPanel.visible = true;
            this.layoutVendorPanel.textboxShpmtIdentType.selectedItem = SHIPMENT_DEFAULT;

        } else if (StringUtil.equalsIgnoreCase(this._vendorId, this.truckerToolsVendorId)) {
            this.layoutBrokerageTrackingCredentialsPanel.TTCredentialsPanel.visible = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxTruckerToolsAccountID.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxMcNumber.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxTruckerToolsUrl.required = true;
            this.layoutVendorPanel.truckerToolsVendorOptionsPanel.visible = true;
            this.layoutMainBrokerageTrackingControlPanel.switchAutoSend.visible = false;

        } else if (StringUtil.equalsIgnoreCase(this._vendorId, this.fourKitesVendorId)) {
            this.layoutBrokerageTrackingCredentialsPanel.panelFourKites.visible = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxFourKitesAccountID.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxFourKitesPassword.required = true;
            this.layoutBrokerageTrackingCredentialsPanel.textboxFourKitesUrl.required = true;
            this.layoutVendorPanel.fourKitesVendorOptions.visible = true;
            this.layoutMainBrokerageTrackingControlPanel.switchAutoSend.visible = false;




        }
    }

    getDefaultData() {
        switch (this._vendorId?.toUpperCase()) {
            case this.macropointVendorId?.toUpperCase():
                return this.activeRow?.get("macropoint_default_values");

            case this.project44VendorId?.toUpperCase():
                return this.activeRow?.get("project44_default_values");

            case this.truckerToolsVendorId?.toUpperCase():
                return this.activeRow?.get("trucker_tools_default_values");

            case this.fourKitesVendorId?.toUpperCase():
                return this.activeRow?.get("fourkites_default_values");

            default:
                return null;
        }
    }
}
